import React from "react";
import { motion } from "framer-motion";
import {
  FaChartBar,
  FaDatabase,
  FaEnvelope,
  FaPaintBrush,
  FaUserTie,
} from "react-icons/fa";
import { servicesData } from "../lib/ui";

const iconMap = {
  FaUserTie: <FaUserTie />,
  FaChartBar: <FaChartBar />,
  FaDatabase: <FaDatabase />,
  FaEnvelope: <FaEnvelope />,
  FaPaintBrush: <FaPaintBrush />,
};

const colorMap = {
  cyan: {
    tag: "tag-cyan",
    accent: "from-app-accent/20 to-transparent",
    glow: "shadow-glow/20",
  },
  violet: {
    tag: "tag-violet",
    accent: "from-app-secondary/20 to-transparent",
    glow: "shadow-glow-v/20",
  },
};

export default function Services() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 auto-rows-[280px] gap-5 lg:gap-6">
      {servicesData.map((service, index) => {
        const c = colorMap[service.color];
        const isLarge = service.gridClass.includes("md:col-span-2");
        const isFull = service.gridClass.includes("md:col-span-3");

        return (
          <motion.div
            key={service.title}
            className={`group relative overflow-hidden glass-card rounded-[32px] transition-all duration-500 border border-app-border hover:border-app-accent/50 ${c.glow} ${service.gridClass}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.05 }}
          >
            {/* Background Image with Gradient Overlay */}
            <div className="absolute inset-0 z-0">
              <img
                src={service.image}
                alt=""
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-40 group-hover:opacity-60"
              />
              <div className={`absolute inset-0 bg-gradient-to-t from-app-bg via-app-bg/60 to-transparent z-10`} />
              <div className={`absolute inset-0 bg-gradient-to-br ${c.accent} opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10`} />
            </div>

            {/* Content Container */}
            <div className="relative z-20 h-full p-6 sm:p-8 flex flex-col justify-end">
              {/* Icon & Title Row */}
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 rounded-2xl bg-app-panel/80 backdrop-blur-md border border-app-border flex items-center justify-center text-xl text-white shadow-sm transition-transform duration-300 group-hover:-translate-y-1">
                  {iconMap[service.iconName]}
                </div>
              </div>

              <div>
                <h3 className={`font-display font-bold text-app-text mb-2 ${isLarge || isFull ? "text-2xl md:text-3xl" : "text-xl"}`}>
                  {service.title}
                </h3>

                <p className={`text-app-mute leading-relaxed mb-6 line-clamp-2 group-hover:line-clamp-none transition-all duration-300 ${isLarge || isFull ? "text-base md:text-lg max-w-xl" : "text-sm"}`}>
                  {service.description}
                </p>

                {/* Tags */}
                <div className="flex flex-wrap gap-2">
                  {service.tags.map((tag) => (
                    <span
                      key={tag}
                      className={`px-3 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-app-panel/80 backdrop-blur-md border border-app-border text-app-text group-hover:border-app-accent/50 transition-colors`}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
